import React from 'react';
import DocumentList from '../../../fields/DocumentList';
import UploadButton from '../../../fields/UploadButton';
import { PromptItem } from '../../../../types/candidateStories';

const FilePromptUploadSection = ({
  item,
  documents,
  onRemove,
  field,
}: {
  item: PromptItem;
  documents: any[];
  onRemove: (index: number) => void;
  field: string;
}) => {
  return (
    <div data-testid={`file-prompt-upload-section-${item.id}`}>
      <div
        className='mb-3 p-3'
        data-testid='candidate-story-upload-btn-section'
      >
        <UploadButton
          name={field}
          id='upload-btn'
          kind='secondary'
          context='candidate-stories'
        />
      </div>
      <div className='form-group'>
        <DocumentList documents={documents} onRemove={onRemove} />
      </div>
    </div>
  );
};

export default FilePromptUploadSection;
